import { UserFrontPrivate } from "@project/shared-types";
import { useContext } from "react";
import { UserContext } from '../model/UserContext';

/**
 * Хук для получения данных пользователя из контекста
 * @returns {Object} Объект с данными пользователя и методами для их изменения
 */
export const useUser = (): UserFrontPrivate | null => {
  const context = useContext(UserContext);
  if (!context) {
    return null;
  }
  return context.user;
};
